import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ContextService } from "../core/context.service";
import { MasterDataService, MasterData } from '../services/master.data.service';
import { UserService } from "../services/user.service";
import { BankService } from '../services/bank.service';

@Component({
  selector: 'tv-report-section',
  templateUrl: './report.section.component.html',
  styleUrls: ['./report.section.component.css']
})
export class ReportSectionComponent implements OnInit, OnChanges {
  @Input() public reportData: any;

  bankName: any;
  loggedInUserName: string;
  userList: Array<any> = [];
  today = new Date();
  monthYear:Date;
  branchName: string;
  fromDate: Date;
  toDate: Date;
    bankLogo: any;
  documentImage: any;
  logoroleId: any;
    branchId: number;
    homeBranchId: number;
  transactionDate: Date;
  reportFormateType: string;
  branchDisplayName: string;
  createdByDisplayName: string;
  title: string;
  branchList: Array<any> = [];

  public reportTypeList: any[] = [
    { id: 1, name: "Predefined" },
    { id: 2, name: "Alphabetical All GL's" },
    { id: 3, name: "Local Language Predefined" }
  ];

  constructor(
    private titleService: Title,
    private masterDataService: MasterDataService,
    private masterData: MasterData,
    private contextService: ContextService,
    private bankService:BankService,
    private userService: UserService
  ) {}

  ngOnInit() {
    console.log('ngOnInit called');
    this.initializeData();
     this.branchId=this.contextService.currentBranchId;
    this.homeBranchId=this.contextService.homeBranchId;
    this.logoroleId = this.contextService.user?.currentBranchPermissions?.roleId;

    this.bankService.getBank().subscribe(resultReqd => {
      this.documentImage = resultReqd.bank.documentImage;

      const base64Image = this.documentImage;
      if (base64Image) {
        this.bankLogo = `data:image/png;base64,${base64Image}`;
      } else {
        this.bankLogo = null;
      }
    });
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['reportData'] && !changes['reportData'].firstChange) {
      console.log('reportData changed:', this.reportData);
      this.initializeData();
    }
  }

  initializeData() {
    if (!this.reportData) return;

    this.transactionDate = this.reportData.transactionDate;
    this.fromDate = this.reportData.fromDate;
    this.monthYear=this.reportData.monthYear;
    this.toDate = this.reportData.toDate;
    this.reportFormateType = this.reportData.reportFormateType;
    this.title = this.reportData.title;

    this.bankName = this.contextService.user.bankName;
    const loggedInUser = this.contextService.user;
    this.loggedInUserName = loggedInUser.userName;

    this.masterDataService.getAll([this.masterData.Branch])
      .subscribe(data => {
        this.branchList = data[0];
        console.log('Got branch data:', this.branchList);
        this.setBranchName();
      }, err => console.log('Get master data failed', err));

    this.userService.getAllUsers().subscribe(
      (data) => {
        this.userList = data;
        console.log("Got user data:", this.userList);
        this.setCreatedByName();
      },
      (err) => console.log("Get user data failed", err)
    );
  }

  setBranchName() {
    if (this.reportData?.branchId !== undefined) {
      if (this.reportData.branchId === -1 || this.reportData.branchId === 0) {
        this.branchDisplayName = 'All Branches';
      } else {
        const branch = this.branchList.find(b => b.id === this.reportData.branchId);
        console.log('branch---', branch);
        this.branchDisplayName = branch ? branch.name : 'Unknown Branch';
      }
    }
  }

  // setCreatedByName() {
  //   if (this.reportData?.createdBy !== undefined) {
  //     if (this.reportData.createdBy === -1) {
  //       this.createdByDisplayName = 'All';
  //     } else {
  //       const user = this.userList.find(u => u.id === this.reportData.createdBy);
  //       this.createdByDisplayName = user ? user.userName : 'Unknown User';
  //     }
  //   }
  // }

  setCreatedByName() {
  if (this.reportData?.createdBy !== undefined) {

    const createdBy = Number(this.reportData.createdBy);

    if (createdBy === 0 || createdBy === -1) {
      this.createdByDisplayName = 'All';
    } else {
      const user = this.userList.find(u => u.id === createdBy);
      this.createdByDisplayName = user ? user.userName : 'Unknown User';
    }
  }
}

  

  getReportFormatTypeName(): string {
    const format = this.reportTypeList.find(f => f.id === this.reportFormateType);
    return format ? format.name : '';
  }
}
